module.exports = __webpack_public_path__ + "static/absa-resource-tile-f7fd677884105c10f5355565ec268605.png";